<template>
  <div>
    <select
      v-model="selectedOption"
      @change="onSearch"
      class="justify-content-end align-self-center pb-1 customgrid-search-bar"
    >
      <option value="">{{ $t("selectOption") }}</option>
      <option value="true">{{ $t("completed") }}</option>
      <option value="false">{{ $t("not-completed") }}</option>
    </select>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  data() {
    return {
      selectedOption: "",
    };
  },
  created() {
    eventBus.$on("clear-filters", this.clearFilters);
  },
  props: {
    columnHeader: String,
    onCustomEvent: Function,
  },
  methods: {
    clearFilters() {
      this.selectedOption = "";
    },
    onSearch() {
      const searchText = this.selectedOption;
      const columnHeader = this.params.columnHeader;
      this.$parent.$listeners.onFilterChanged(columnHeader, searchText);
    },
  },
};
</script>
